<template>
  <div class='header'>
    <div class="content flex-between">
      <!-- <div class="flex-column leftText" style="color: #1E263A;flex: 0 0 15%;" :style="{ color: $route.path == '/home' ? (isSticky ? '#0092FF' : '#333') : $route.path == '/homePage' ? (isSticky ? '#0092FF' : '#333') : '#0092FF' }
                ">
                <div class="logoText">千顷职汇</div>
                <div class="">yuyingrencai</div>
            </div> -->
      <el-image :src=" $route.path == '/homePage'?isSticky?require(`@/static/image/logo.png`):require(`@/static/image/logo.png`):require(`@/static/image/logo.png`) "
                style="width: 119px;height: 28px; "
                fit="fill"></el-image>
      <ul class="list"
          style="flex: 0 0 60%;padding-left: 50px;">
        <li v-for="(item, index) in titleList"
            :key="index"
            style="border-bottom:3px solid transparent;padding-bottom: 5px;"
            :style="{
                        borderColor: $route.path == `/${item.url}` ? '#0092FF' : 'transparent'
                    }"
            @click="scrollToTop">
          <router-link :to="'/' + item.url">{{ item.name }}</router-link>
        </li>
      </ul>
      <div class="flex"
           style="flex:0 0 20%;justify-content:end"
           v-if="!token">
        <div style="margin-right: 20px;"
             @click="$router.push('/login')"
             class="cursor">立即登录</div>
        <!-- <el-button type="primary" size="mini" @click="$router.push('/register')">注册</el-button> -->
      </div>
      <div class="flex"
           style="flex:0 0 20%;justify-content:end"
           v-else>
        <el-avatar :size="38"
                   :src="userPic"
                   style="margin-right: 10px;"></el-avatar>
        <span style="margin-right: 10px;">{{userName}}</span>
        <el-button type="primary"
                   size="mini"
                   @click="loginOut">退出</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import config from '@/config/config'
export default {
  name: '',
  components: {},
  props: ['isSticky'],
  data() {
    return {
      titleList: [
        { name: '首页', url: 'homePage' },
        { name: '招聘订单', url: 'RecruitmentOrder' },
        { name: '我的订单', url: 'MyOrder' },
        { name: '个人中心', url: 'PersonalCenter' },
        { name: '代理中心', url: 'AgentCenter' },
        { name: '关于我们', url: 'AboutUs' },
      ],
      token: localStorage.getItem('token'),
      userName: localStorage.getItem('userName'),
      userPic: config.config + localStorage.getItem('userPic'),
    }
  },
  computed: {},
  watch: {},
  methods: {
    scrollToTop() {
      this.$parent.scrollToTop()
    },
    loginOut() {
      localStorage.setItem('token', '')
      localStorage.setItem('userName', '')
      localStorage.setItem('userPic', '')
      this.$router.push('/homePage')
      this.$router.go(0)
    },
  },
  created() {},
  mounted() {},
}
</script>
<style lang='scss' scoped>
.header {
  // background-color: #B3C0D1;
  color: #333;
  height: 60px;
  z-index: 99999;

  .list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    font-size: 0;

    li {
      display: inline-block;
      font-size: 16px;
      margin-right: 40px;
      color: #333;
    }
  }
}

a {
  color: #333 !important;
}
.cursor {
  width: 82px;
  height: 32px;
  background: #0092ff;
  border-radius: 6px;
  text-align: center;
  line-height: 32px;
  color: #fff;
}
</style>